// extracted by mini-css-extract-plugin
export default {"navegacao":"MenuNav_navegacao__-u-Qq","link":"MenuNav_link__nKjN1","linkAtivo":"MenuNav_linkAtivo__n+I0Z"};